import React from "react";
import { Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { MESSAGE_STATUS } from "../../socket/events";

/**
 * WhatsApp style delivery ticks for a message you sent.
 *
 *   sending   -> clock
 *   sent      -> single grey tick
 *   delivered -> double grey tick
 *   seen      -> double blue tick
 *   failed    -> red warning
 */
export const MessageTicks = ({ status, size = 16 }) => {
  const sx = { fontSize: size, verticalAlign: "middle" };

  switch (status) {
    case MESSAGE_STATUS.SENDING:
      return (
        <Tooltip title="Sending">
          <AccessTimeIcon sx={{ ...sx, color: "#9e9e9e" }} />
        </Tooltip>
      );

    case MESSAGE_STATUS.FAILED:
      return (
        <Tooltip title="Not sent — tap to retry">
          <ErrorOutlineIcon sx={{ ...sx, color: "#e53935" }} />
        </Tooltip>
      );

    case MESSAGE_STATUS.DELIVERED:
      return (
        <Tooltip title="Delivered">
          <DoneAllIcon sx={{ ...sx, color: "#9e9e9e" }} />
        </Tooltip>
      );

    case MESSAGE_STATUS.SEEN:
      return (
        <Tooltip title="Seen">
          <DoneAllIcon sx={{ ...sx, color: "#2F378D" }} />
        </Tooltip>
      );

    case MESSAGE_STATUS.SENT:
    default:
      return (
        <Tooltip title="Sent">
          <DoneIcon sx={{ ...sx, color: "#9e9e9e" }} />
        </Tooltip>
      );
  }
};

export default MessageTicks;
